import React from 'react';
import { StyleSheet } from 'react-native';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';

const styles = StyleSheet.create({
  container: {
    width: '100vw',
    height: 'var(--beacon-viewport-height, 100vh)',
    padding: 15,
    overflow: 'hidden',
  },
  body: {
    flex: 1,
    padding: 0,
  },
  iframeContainer: {
    borderColor: colors['color-gray-100'],
    borderWidth: 1,
    overflow: 'hidden',
  },
})

const iframeStyle: React.CSSProperties = {
  width: '100%',
  height: '100%',
  flex: 1,
  border: 0,
}

export const tabletPreviewModalStyles = {
  ...styles,
  iframe: iframeStyle,
}

export const tabletPreviewModalPositionStyle = {
  left: '0px',
  top: '0px',
}

export const tabletPreviewModalContentStyle = {
  maxHeight: 'var(--beacon-viewport-height, 100vh)',
}

export default styles;
